<template>
  <div class="max-w-md mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
    <div class="px-6 py-8">
      <h2 class="text-2xl font-bold text-center mb-8">用户登录</h2>
      
      <!-- 登录表单 -->
      <form @submit.prevent="handleLogin">
        <div class="mb-4">
          <label class="block text-sm font-medium mb-2" for="email">邮箱/手机号</label>
          <input v-model="form.email" 
                 type="email" 
                 id="email" 
                 class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                 placeholder="请输入邮箱或手机号">
          <span v-if="errors.email" class="text-danger text-sm mt-1 block">{{ errors.email }}</span>
        </div>
        
        <div class="mb-6">
          <div class="flex justify-between mb-2">
            <label class="block text-sm font-medium" for="password">密码</label>
            <router-link to="#" class="text-sm text-primary hover:underline">忘记密码？</router-link>
          </div>
          <input v-model="form.password" 
                 type="password" 
                 id="password" 
                 class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                 placeholder="请输入密码">
          <span v-if="errors.password" class="text-danger text-sm mt-1 block">{{ errors.password }}</span>
        </div>
        
        <div class="mb-6">
          <label class="flex items-center">
            <input type="checkbox" class="mr-2">
            <span class="text-sm">记住我</span>
          </label>
        </div>
        
        <button type="submit" 
                class="w-full bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                :disabled="loading">
          <i v-if="loading" class="fa fa-spinner fa-spin mr-2"></i>
          登录
        </button>
      </form>
      
      <!-- 其他登录方式 -->
      <div class="mt-8">
        <div class="relative flex items-center justify-center">
          <hr class="w-full border-neutral-200">
          <span class="absolute bg-white px-2 text-sm text-neutral-500">其他登录方式</span>
        </div>
        
        <div class="flex justify-center space-x-6 mt-6">
          <button class="w-12 h-12 rounded-full bg-[#07C160] flex items-center justify-center text-white">
            <i class="fa fa-weixin text-xl"></i>
          </button>
          <button class="w-12 h-12 rounded-full bg-[#1DA1F2] flex items-center justify-center text-white">
            <i class="fa fa-twitter text-xl"></i>
          </button>
          <button class="w-12 h-12 rounded-full bg-[#EA4335] flex items-center justify-center text-white">
            <i class="fa fa-google text-xl"></i>
          </button>
        </div>
      </div>
      
      <!-- 注册链接 -->
      <div class="mt-8 text-center">
        <span class="text-neutral-500">还没有账号？</span>
        <router-link to="/register" class="text-primary font-medium hover:underline ml-1">立即注册</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      errors: {},
      loading: false
    }
  },
  methods: {
    validateForm() {
      this.errors = {}
      
      if (!this.form.email) {
        this.errors.email = '请输入邮箱或手机号'
      } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^1[3-9]\d{9}$/.test(this.form.email)) {
        this.errors.email = '请输入有效的邮箱或手机号'
      }
      
      if (!this.form.password) {
        this.errors.password = '请输入密码'
      } else if (this.form.password.length < 6) {
        this.errors.password = '密码长度不能少于6位'
      }
      
      return Object.keys(this.errors).length === 0
    },
    handleLogin() {
      if (!this.validateForm()) return
      
      this.loading = true
      
      // 模拟登录请求
      setTimeout(() => {
        this.loading = false
        this.$router.push('/')
        this.$bus.$emit('showMessage', '登录成功！')
      }, 1500)
    }
  }
}
</script>